import {login, logout, regist} from '@/api'
import {getToken, getUserInfo, removeToken, removeUserInfo, setToken, setUserInfo} from '@/utils/auth'


const state = () => ({
  token: getToken(),
  userInfo: getUserInfo(),
})

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
}

const actions = {
  // user login
  login({ commit, state, dispatch }, req) {
    return new Promise((resolve, reject) => {
      login(req).then(res => {
        let {data} = res
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        commit('SET_USERINFO', data)
        setUserInfo(data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  regist({ commit }, req) {
    return new Promise((resolve, reject) => {
      regist(req).then(res => {
        let {data} = res
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        commit('SET_USERINFO', data)
        setUserInfo(data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  logout({ commit, state, dispatch },req) {
    return new Promise((resolve, reject) => {
      logout(req).then(res => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', null)
        removeToken()
        removeUserInfo()
        resolve()
        window.location.reload()
      }).catch(err => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', null)
        removeToken()
        removeUserInfo()
        resolve()
        window.location.reload()
        reject(err)
      })
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
